// Regex: #tag-name (letters, numbers, hyphens, underscores, dots)
// Must start with # followed by at least one valid character
const TAG_REGEX = /#([a-zA-Z0-9._-]+)/g;

/**
 * Parse hashtags from text
 * @param {string} text - Text to parse (e.g., card description)
 * @returns {string[]} - Array of unique tag names (without # prefix)
 */
export const parseTags = (text) => {
  if (!text) {
    return [];
  }

  const matches = text.match(TAG_REGEX);

  if (!matches) {
    return [];
  }

  // Remove # prefix and deduplicate
  const tags = matches.map((match) => match.slice(1));
  return [...new Set(tags)];
};

export default parseTags;
